import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Box, Users, Contact } from "lucide-react";
import { SYSTEM_ICON } from "../../../constants/entity-icons";
import { Avatar, AvatarFallback, AvatarImage } from "../../base/avatar/avatar";
import { Badge } from "../../base/badge/badge";
import { Item, ItemActions, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "../../base/item/item";
import { getInitials } from "../../../utils/user-utils";
import { EntityIcon } from "./EntityIcon";
import { ORG_FUNCTION_KIND_TONES } from "./OrgFunctionKindBadge";
const KIND_DEFAULTS = {
    process: {
        tone: "green",
        icon: /*#__PURE__*/ _jsx(Box, {
            className: "h-[18px] w-[18px]"
        })
    },
    system: {
        tone: "blue",
        icon: /*#__PURE__*/ _jsx(SYSTEM_ICON, {
            className: "h-[18px] w-[18px]"
        })
    },
    // OrgFunction kinds consume the shared kind-tone tokens so badge and icon
    // colors can't drift apart across surfaces.
    team: {
        tone: ORG_FUNCTION_KIND_TONES.team,
        icon: /*#__PURE__*/ _jsx(Users, {
            className: "h-[18px] w-[18px]"
        })
    },
    role: {
        tone: ORG_FUNCTION_KIND_TONES.role,
        icon: /*#__PURE__*/ _jsx(Contact, {
            className: "h-[18px] w-[18px]"
        })
    }
};
export function EntityCard({ kind, person, name, sub, icon, pill, pillTone = "blue", action, compact = false, className }) {
    const displayName = person?.name ?? name ?? "";
    const displaySub = person?.role ?? sub;
    let media = null;
    if (person) {
        media = /*#__PURE__*/ _jsx(ItemMedia, {
            variant: "image",
            children: /*#__PURE__*/ _jsxs(Avatar, {
                children: [
                    person.avatarUrl && /*#__PURE__*/ _jsx(AvatarImage, {
                        src: person.avatarUrl,
                        alt: person.name
                    }),
                    /*#__PURE__*/ _jsx(AvatarFallback, {
                        children: getInitials(person.name)
                    })
                ]
            })
        });
    } else if (icon) {
        media = /*#__PURE__*/ _jsx(ItemMedia, {
            children: /*#__PURE__*/ _jsx(EntityIcon, {
                icon: icon,
                tone: "neutral"
            })
        });
    } else if (kind && kind !== "person") {
        const def = KIND_DEFAULTS[kind];
        media = /*#__PURE__*/ _jsx(ItemMedia, {
            children: /*#__PURE__*/ _jsx(EntityIcon, {
                icon: def.icon,
                tone: def.tone
            })
        });
    }
    return /*#__PURE__*/ _jsxs(Item, {
        variant: "outline",
        size: compact ? "sm" : "default",
        className: className,
        children: [
            media,
            /*#__PURE__*/ _jsxs(ItemContent, {
                children: [
                    /*#__PURE__*/ _jsx(ItemTitle, {
                        children: displayName
                    }),
                    displaySub && /*#__PURE__*/ _jsx(ItemDescription, {
                        children: displaySub
                    })
                ]
            }),
            pill && /*#__PURE__*/ _jsx(Badge, {
                variant: "outline",
                shape: "pill",
                colorScheme: pillTone,
                children: pill
            }),
            action && /*#__PURE__*/ _jsx(ItemActions, {
                children: action
            })
        ]
    });
}

//# sourceMappingURL=EntityCard.js.map